import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BusinessRepresentativeFormObject } from 'src/app/shared/models/business-representative/business-representative-form-object/business-representative-form-object';

@Component({
  selector: 'app-business-representative-form',
  templateUrl: './business-representative-form.component.html',
  styleUrls: ['./business-representative-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Represent third section of register page
 */
export class BusinessRepresentativeFormComponent {
  @Input() businessRepresentative!: BusinessRepresentativeFormObject;
  @Input() animateImage = false;
  @Input() migrating = false;
  private _hideInform = false;

  /**
   * If this component should hide its informative text
   */
  @Input()
  get hideInform() {
    return this._hideInform;
  }

  /**
   * Sets hide inform value from directive
   * @param {any} value
   */
  set hideInform(value: any) {
    this._hideInform = coerceBooleanProperty(value);
  }

  /**
   * Returns a control from business representative's form group
   * @param {string} controlName
   * @return {FormControl}
   */
  getControl(controlName: string): FormControl {
    return this.businessRepresentative.formGroup.get(
      controlName
    ) as FormControl;
  }
}
